export { default as DefaultAddress } from './address/DefaultAddress'
export { default as CustomerQuotes } from './customerQuotes/customerQuotes'
export { default as PressQuotes } from './pressQuotes/pressQuotes'
export {default as Markdown} from './markdown/markdown'
export * from './inputs'
export { default as DefaultPayment } from './payment/DefaultPayment'
export * from './sections'
export * from './social-media'
export * from './video'
export * from './aboutUs'



// WEBPACK FOOTER //
// ./src/components/index.js